import { useContext, useEffect, useState } from 'react';

import { ctxRoutes } from '@/contexts/RoutesCtx';
import { MinimalStatusCollection } from '@/generated/model';

export function useRouteLoader() {
  const routesCtx = useContext(ctxRoutes);
  const [highlighted, setHighlighted] = useState<MinimalStatusCollection[] | undefined>(undefined);
  const [gray, setGray] = useState<MinimalStatusCollection[] | undefined>(undefined);

  useEffect(() => {
    setHighlighted([]);
    setGray([]);
    if (!routesCtx || !routesCtx.positions) {
      return;
    }
    const positions = routesCtx.positions;
    if (routesCtx.highlightedRoutes?.length === 0) {
      setHighlighted(positions);
    } else {
      positions.map((r) => {
        if (routesCtx.highlightedRoutes?.includes(r.routeId)) {
          setHighlighted((prev) => (prev ? [...prev, r] : [r]));
        } else {
          setGray((prev) => (prev ? [...prev, r] : [r]));
        }
      });
    }
  }, [routesCtx?.positions, routesCtx?.highlightedRoutes]);

  return [highlighted, gray];
}
